export default "__VITE_ASSET__DpFNXKnj__"